<template lang="pug">
.primary-btn(@click="active? $emit('clicked'): {}" :class="active? 'active': ''") {{$t(`btn.${type}`)}}
  .notice {{notice}}
  
</template>
<script>
export default {
  name: 'PrimaryBtn',
  props: {
    type: {},
    active: {},
    notice: {},
  },
  data() {
    return {}
  },
  computed: {},
  methods: {},
  mounted() {},
}
</script>

<style scoped lang="sass">
@import "src/styles/common.sass"
.primary-btn
  position: relative
  top: -20%
  width: 100%
  height: pxToRem(98)
  background-image: linear-gradient(135deg, #168BFF 0%, #1664FF 100%)
  box-shadow: pxToRem(2) pxToRem(13) pxToRem(23) pxToRem(-10) rgba(22,139,255,0.60)
  border-radius: pxToRem(8)
  font-size: pxToRem(36)
  line-height: pxToRem(98)
  color: #ffffff
  text-align: center
  filter: grayscale(1)
  transition: filter 0.5s ease
  .notice
    font-size: 12px
    color: #999999
    position: absolute
    width: 100%
    text-align: center
    top: -24px
    line-height: 12px
  &.active
    filter: none
</style>
